import { render, staticRenderFns } from "./PeakIcon.vue?vue&type=template&id=2891e00e&scoped=true"
import script from "./PeakIcon.vue?vue&type=script&lang=js"
export * from "./PeakIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2891e00e",
  null
  
)

export default component.exports